import { createSlice } from '@reduxjs/toolkit'
import identity from 'lodash/identity.js'
import { createSliceTransformer } from 'rtk-slice-transformer'
import { fetchSystemInfo } from '../thunks/index.js'
import type { FeatureFlags } from '../types/FeatureFlags.js'

export type FeatureFlagsState = {
	readonly flags: Maybe<FeatureFlags>
}

export type WithFeatureFlagsState = {
	readonly fflags: FeatureFlagsState
}

const initialState: FeatureFlagsState = {
	flags: null,
}

export const featureFlagsSlice = /*@__PURE__*/ createSlice({
	name: 'fflags',
	initialState,
	reducers: {},
	extraReducers: (builder) =>
		builder.addCase(fetchSystemInfo.fulfilled, (s, a) => {
			if (a.payload.feature_flags) {
				s.flags = a.payload.feature_flags
			}
		}),
})

export const featureFlagsSliceTransformer = /*@__PURE__*/ createSliceTransformer(
	featureFlagsSlice,
	identity,
)
